/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  BedBathInfo minimal component
 */

import type { InjectEmotionCSSType } from '@zcode-ui/controls'
import { toTitleCase } from '@zcode/nr/es/shared/utils'
import type { Listable } from '@zcode/state-type'
import React, { useMemo } from 'react'
import { getBedAndBathText } from '../helpers/getBedAndBathText'

export interface Props
  extends Pick<Listable, 'bathroomTxt' | 'bedroomTxt' | 'bedsBathsRangeTxt' | 'isBuilding'> {
  bathrooms: number
  styles: InjectEmotionCSSType
}

export const BedBathInfoMin = ({
  bathroomTxt,
  bathrooms,
  bedsBathsRangeTxt,
  bedroomTxt,
  isBuilding,
}: Props) => {
  const fullBedAndBathText = useMemo(() => {
    const [bedTxt, bathTxt] = getBedAndBathText({
      bathroomTxt,
      bedsBathsRangeTxt,
      bedroomTxt,
      isBuilding,
    })
    return bathrooms && bathrooms > 0
      ? [toTitleCase(bedTxt), toTitleCase(bathTxt)].join(' • ')
      : toTitleCase(bedTxt)
  }, [bathrooms, bathroomTxt, bedsBathsRangeTxt, bedroomTxt, isBuilding])

  return <div className="text-gray-600 text-sm">{fullBedAndBathText}</div>
}
